module.exports = __webpack_public_path__ + "static/media/galleryImg18.9dec7ceb.jpg";